import vue from 'vue'
import {getRegCode, register} from "@/services/register";
import {Message, MessageBox} from "element-ui";
import router from '@/router';

const state = {};

const getters = {};

const actions = {
  getRegCode({commit, dispatch}, objc) {
    getRegCode(objc).then((res) => {
      const {code, data, msg} = res;
      if (code == 0 && data) {
        //获取注册验证码处理
        Message.success('验证码已发送至您的手机，注意查收！');
      } else {
        Message.warning(msg);
      }
    })
  },
  handleReg({commit, dispatch}, objc) {
    register({...objc.params}).then((res) => {
      let {code, data} = res;
      if (code == 0 && data.user_info) {
        const {identity, userTypr} = data.user_info;
        //todo 登录后判断用户是否已经进行身份确认，没有确认跳转至身份确认
        if (identity == 0 && userTypr == 4) {
          router.push('/');
          Message.success('注册成功！');
        }
      }
    })
  },
};

const mutations = {
  updateState: (state, payload) => {
    vue.set(state, payload.state, payload.update);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/register/modules/register.js